var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.resource.subtitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.resource.content)}}),_c('iframe',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.embedURL,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }